import React, {Component} from "react";
import "./Slider.css";

class Slider extends Component {
	state = {

	}

	componentDidMount(){

	}

	render(){


		
		return(
			<section id="home">\
				<div className="slider fullscreen scrollspy hide-on-med-and-down ">
				<ul className="slides">
				<li className='hide-on-med-and-down'>
						<img src="/assets/img/background1.jpg" alt="By Louie Bross from BSNSCB" />
						<div className="caption center-align " id="slides">
							<h3 className="grey-text text-lighten-2">Welcome to Shawhien&apos;s <strong className="blue-text text-lighten-2">Portfolio</strong>!</h3>
							<h5 className="light grey-text text-lighten-5"><strong></strong></h5>
						</div>
					</li>
				
					<li className="hide-on-med-and-upp">
						<img src="/assets/img/background2.jpg" alt="By Travis Seera from Pexels" />
						<div className="caption center-align">
							{/* <h3 className="grey-text text-lighten-2">Welcome to Shawhien&apos;s <strong className="blue-text text-darken-5">Portfolio</strong>!</h3> */}
							<h5 className="light grey-text text-lighten-5"><strong></strong></h5>
						</div>
					</li>
					{/* <li>
						<img src="/assets/img/background3.jpg" alt="By Johan Bos from Pexels" />
						<div className="caption left-align">
							<h3 className="black-text"><strong className="red-text darken-text-4"></strong></h3>
							<h5 className="white-text  hide-on-small-only"></h5>
						</div>
					</li> */}
					<li className="hide-on-med-and-down">
						<img src="/assets/img/background4.jpg" alt="Negative Space from Pexels" />
						<div className="caption right-align" id="slides">
							<h3></h3>
							<h5 className="light grey-text text-lighten-5"></h5>
						</div>
					</li>
				</ul>
				</div>
			</section>
		
			
		)
	}
}

export default Slider;

// <li>
// 	<img src="/assets/img/domo5.jpg" alt="MERNster coder" />
// 	<div className="caption right-align">
// 		<h3>The <strong><span className="red-text darken-text-4">MERNster</span></strong> Coder!</h3>
// 		<h5 className="light grey-text text-lighten-5 hide-on-small-only"><strong>Do you even flexbox?!? --Joe Faulstick</strong></h5>
// 	</div>
// </li>


// WEBPACK FOOTER //
// ./src/components/Slider/Slider.js